import {
  GET_SKULOOKUP_DATA_REQUEST,
  GET_SKULOOKUP_DATA_SUCCESS,
  GET_SKULOOKUP_DATA_ERROR,
  GET_SKULOOKUP_DATA_PK_STOCK_REQUEST,
  GET_SKULOOKUP_DATA_PK_STOCK_SUCCESS,
  GET_SKULOOKUP_DATA_PK_STOCK_ERROR,
  GET_PRODUCTION_REASON_REPORT_REQUEST,
  GET_PRODUCTION_REASON_REPORT_SUCCESS,
  GET_PRODUCTION_REASON_REPORT_ERROR,
  GET_OTS_SIZE_WITH_ETA_REQUEST,
  GET_OTS_SIZE_WITH_ETA_SUCCESS,
  GET_OTS_SIZE_WITH_ETA_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";


export const getskuloopUpData = (token, values) => (dispatch) => {
  dispatch({ type: GET_SKULOOKUP_DATA_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/SkuLookupData`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values,
  })
    .then((response) => {
      return dispatch({
        type: GET_SKULOOKUP_DATA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SKULOOKUP_DATA_ERROR,
        payload: [],
      });
    });
};

export const getOtsSizeWithETA = (token, values) => (dispatch) => {
  dispatch({ type: GET_OTS_SIZE_WITH_ETA_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/OtsBySizeWithEta`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values,
  })
    .then((response) => {
      return dispatch({
        type: GET_OTS_SIZE_WITH_ETA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_OTS_SIZE_WITH_ETA_ERROR,
        payload: [],
      });
    });
};


export const getskuloopUpDataPkStock = (token, values) => (dispatch) => {
  dispatch({ type: GET_SKULOOKUP_DATA_PK_STOCK_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/immediateOtsSizeForPkstock`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values,
  })
    .then((response) => {
      return dispatch({
        type: GET_SKULOOKUP_DATA_PK_STOCK_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SKULOOKUP_DATA_PK_STOCK_ERROR,
        payload: [],
      });
    });
};


export const getOpOts = (token, values) => (dispatch) => {
  dispatch({ type: GET_PRODUCTION_REASON_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/OffPriceOtsReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values,
  })
    .then((response) => {
      return dispatch({
        type: GET_PRODUCTION_REASON_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCTION_REASON_REPORT_ERROR,
        payload: [],
      });
    });
};